import React, { useEffect, useState, useRef } from 'react';
import AdminHeading from '../AdminPanel/Heading/AdminHeading';
import AdminBreadCrump from '../AdminPanel/Heading/AdminBreadCrump';
// import "../PagesStyles/AdminMasters.css";

import style from './CustomerTouncheNew.module.css';
import {
  a104,
  a107,
  a125,
  a128,
  a131,
  a134,
  a149,
  a163,
  a173,
  a174,
  a179,
  a180,
  a191,
  a204,
  a205,
  a206,
  a742,
  a744,
  a747,
  a95,
  a98,
} from '../../Api/RootApiPath';
import { Icon } from '@iconify/react';
import { useSelector } from 'react-redux';
import { RiListUnordered, RiPlayListAddLine } from 'react-icons/ri';
import AlertMessage from '../../Other Functions/AlertMessage';
import Stonetounch from '../../support/customertounchsupport/stones.jsx';
import GetApiService from '../../Api/getapiService.jsx';
import Customertable from 'Components/support/customervendor/customer';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fetchAllSku, fetchAllStones } from 'services/generalService';
import TounchSkuTable from 'Components/CommonComponents/TounchSkuTable';
import {
  VendorTounchSkuColumns,
  VendorTounchStonesColumns,
} from 'utils/helpers';
import toast from 'react-hot-toast';
import { fetchCustomerTouncheList } from 'services/Tounches';

// src\Components\Api\getapiService.jsx

export default function CustomerTouncheNew({
  editStatus = false,
  editData = {},
  editId = null,
}) {
  const navigate = useNavigate();
  const [active, setActive] = useState('List');
  const [showError, setShowError] = useState(false);
  const [messageType, setMessageType] = useState('');
  const [messageToShow, setMessageToShow] = useState('');
  const [loading, setLoading] = useState(false);
  const [productsData, setProductsData] = useState([]);
  const [categoriesData, setCategoriesData] = useState([]);
  const [designData, setDesignData] = useState([]);
  const [purityData, setPurityData] = useState([]);
  const [skuData, setSkuData] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [allCustomers, setAllCustomers] = useState([]);
  const [newCategory, setNewCategory] = useState({
    CustomerId: 0,
    CustomerName: '',
    CategoryId: 0,
    ProductId: 0,
    DesignId: 0,
    ClientCode: '',
    PurityId: 0,
    WastageWt: 0,
    FinePercentage: 0,
    StoneLessPercent: '0',
    MakingFixedAmt: '0',
    MakingPerGram: '0',
    MakingFixedWastage: '0',
    MakingPercentage: '0',
    StockKeepingUnit: '',
    CompanyId: 0,
    CounterId: 0,
    BranchId: 0,
    EmployeeId: 0,
    OldEntry: false,
    DiamondSizeWeightRateTemplateId: 0,
    DiamondSizeWeightRateTemplateName: '',
    Stones: [],
  });
  const [allCompaniesList, setAllCompaniesList] = useState([]);
  const [allBranchesList, setAllBranchesList] = useState([]);
  const [allDepartmentsList, setAllDepartmentsList] = useState([]);
  const [allRolesList, setAllRolesList] = useState([]);
  const [allSelectedTounche, setAllSelectedTounche] = useState([]);
  const [allSelectedSkus, setAllSelectedSkus] = useState([]);
  const [allSelectedStones, setAllSelectedStones] = useState([]);
  const [allSelected, setAllSelected] = useState(false);
  const [templateData, setTemplateData] = useState([]);
  const [isReset, setIsReset] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  //   let Entryby_Staff_id = parseInt(adminLoggedIn);
  const clientCode = adminLoggedIn.ClientCode;
  const employeeCode = adminLoggedIn.EmployeeCode;
  const CompanyId = adminLoggedIn.CompanyId;
  const BranchId = adminLoggedIn.BranchId;
  const CounterId = adminLoggedIn.CounterId;
  const EmployeeId = adminLoggedIn.EmployeeId;
  const [allStonesList, setAllStonesList] = useState([]);
  const [allStonesList1, setAllStonesList1] = useState([]);
  const [showSKU, setShowSKU] = useState(true);

  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const inputRef5 = useRef(null);
  const inputRef6 = useRef(null);
  const inputRef7 = useRef(null);
  const inputRef8 = useRef(null);
  const inputRef9 = useRef(null);
  const inputRef10 = useRef(null);
  const inputRef11 = useRef(null);

  const {
    data: allSku,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['vendorTounche/fetchAllSku', clientCode],
    queryFn: fetchAllSku,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });
  const {
    data: allCustomerTounch,
    isLoading: allCustomerTounchIsLoading,
    isError: allCustomerTounchIsError,
    refetch,
  } = useQuery({
    queryKey: ['customerTounche/add/fetchAllCustomerTounch', clientCode],
    queryFn: fetchCustomerTouncheList,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });
  const {
    data: allStones,
    isLoading: stoneLoading,
    isError: stoneIsError,
  } = useQuery({
    queryKey: ['vendorTounche/fetchAllStones', clientCode],
    queryFn: fetchAllStones,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });

  useEffect(() => {
    if (editStatus) {
      setNewCategory({
        ...editData,
        CustomerId: editData?.CustomerId,

        CategoryId: editData?.CategoryId,
        ProductId: editData?.ProductId,
        DesignId: editData?.DesignId,

        PurityId: editData?.PurityId,
        WastageWt: editData?.WastageWt,
        FinePercentage: editData?.FinePercentage,
        MakingFixedAmt: editData?.MakingFixedAmt,
        MakingPerGram: editData?.MakingPerGram,
        MakingFixedWastage: editData?.MakingFixedWastage,
        MakingPercentage: editData?.MakingPercentage,
        DiamondSizeWeightRateTemplateId:
          editData?.DiamondSizeWeightRateTemplateId,
      });
    }
  }, [editStatus]);
  // Focus inputRef1 on component mount
  useEffect(() => {
    inputRef1.current?.focus();
  }, []);

  // Handler function to move focus on Enter key press
  const handleKeyPress = (e, nextInputRef) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent default form submission on Enter
      if (nextInputRef) {
        nextInputRef.current?.focus();
      } else {
        if (submitButtonRef.current) {
          submitButtonRef.current.click(); // Safely trigger click
        } else {
          console.error('Submit button ref is not available');
        }
      }
    }
  };
  const [searchInput, setSearchInput] = useState('');

  const handleReset = () => {
    // List of all input and select refs
    const allRefs = [
      inputRef1,
      inputRef2,
      inputRef3,
      inputRef4,
      inputRef5,
      inputRef6,
      inputRef7,
      inputRef8,
      inputRef9,
      inputRef10,
      inputRef11,
    ];

    // Loop through each ref and reset the value
    allRefs.forEach((ref) => {
      if (ref.current) {
        if (ref.current.tagName === 'SELECT') {
          ref.current.selectedIndex = 0; // Reset <select> to the first option
        } else {
          ref.current.value = ''; // Clear input field
        }
      }
    });

    // Refocus on the first input after reset
    inputRef1.current?.focus();
  };

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  useEffect(() => {
    async function getDiamondTemplates() {
      const formData = {
        ClientCode: clientCode,
      };
      const response = await fetch(a191, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjIwMzc1MDA4NTksImlzcyI6Ijk4Nzk4ODc2NzU3NjU2NjU0NjU0IiwiYXVkIjoiSW5mb0Bsb3lhbHN0cmluZy5jb20ifQ.nOtc537wlSYm_97ljruCyOcG7wjXOrNUtxZy206OfOQ',
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      const processedData = data?.map((item) => ({
        templateID: item?.Id,
        templateName: item?.TemplateName || 'default',
      }));
      setTemplateData(processedData);
    }

    getDiamondTemplates();
  }, []);

  const fetchAllCategory = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a204, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllCategories(data);
      } else {
        setActive('addNew');
        document
          .getElementById('addCategoryListTitle')
          .classList.add('activeCategoryTitle');
        document
          .getElementById('addCategoryListLogo')
          .classList.add('activeCategoryLogo');
        document.getElementById('addCategoryListTitle').click();
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllCategory();
  }, []);

  useEffect(() => {
    const formData = {
      ClientCode: clientCode,
    };
    fetch(a125, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => setCategoriesData(data));
  }, []);

  useEffect(() => {
    const formData = {
      ClientCode: clientCode,
    };
    fetch(a128, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((x) => x.json())
      .then((y) => setProductsData(y));
  }, []);

  const filtreredProducts = productsData.filter(
    (x) => x.CategoryId == newCategory.CategoryId
  );

  const filteredDesign = designData.filter(
    (x) => x.ProductId == newCategory.ProductId
  );

  useEffect(() => {
    const formData = {
      ClientCode: clientCode,
    };
    fetch(a134, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => setPurityData(data));
  }, []);

  useEffect(() => {
    const formData = {
      ClientCode: clientCode,
    };
    fetch(a131, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => setDesignData(data));
  }, []);

  useEffect(() => {
    const formData = {
      ClientCode: clientCode,
    };
    fetch(a163, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => setSkuData(data));
  }, []);

  const fetchAllCompanies = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a95, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllCompaniesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllCompanies();
  }, []);

  const fetchAllBranches = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a98, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllBranchesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllBranches();
  }, []);

  const fetchAllDepartments = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a104, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllDepartmentsList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllDepartments();
  }, []);

  const fetchAllRoles = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a107, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllRolesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllRoles();
  }, []);

  const fetchAllCustomers = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a173, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllCustomers(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllCustomers();
  }, []);

  const handleNewCategoryChange = (e) => {
    const { name, value } = e.target;
    let actualValue = value;
    if (name === 'FinePure') {
      actualValue = value === 'true';
    }
    if (name == 'StockKeepingUnit') {
      let selectedSku = skuData.find((x) => x.StockKeepingUnit == value);
      if (selectedSku) {
        handleAllSelectedTounche(e, selectedSku);
      } else {
        setNewCategory({ ...newCategory, [name]: actualValue });
      }
    }
    // CustomerName:`${newCategory.CustomerName}`,
    //   WastageWt:`${newCategory.WastageWt}`,
    //   DiamondSizeWeightRateTemplateName:`${newCategory.DiamondSizeWeightRateTemplateName}`,

    console.log(name);
    console.log(value);
    if (name == 'CustomerId') {
      let cname = allCustomers?.find((item) => item?.Id == actualValue);

      setNewCategory({
        ...newCategory,
        [name]: actualValue,
        CustomerName: cname?.FirstName || '',
      });
    } else if (name == 'DiamondSizeWeightRateTemplateId') {
      let tname = templateData?.find((item) => item?.templateID == actualValue);
      setNewCategory({
        ...newCategory,
        [name]: actualValue,
        DiamondSizeWeightRateTemplateName: tname?.templateName,
      });
    } else {
      setNewCategory({ ...newCategory, [name]: actualValue });
    }
  };

  const addNewCategory = async (e) => {
    e.preventDefault();
    setLoading(true);

    console.log(allSelectedSkus);
    if (allSelectedTounche.length === 0) {
      if (
        activeTab == 1 &&
        (!newCategory.CustomerId ||
          !newCategory.CategoryId ||
          !newCategory.ProductId ||
          !newCategory.DesignId ||
          !newCategory.PurityId) &&
        !allSelectedSkus?.length
      ) {
        alert(
          'Please choose SKU or provide Category, Product, and Purity details.'
        );
        setLoading(false);
        return;
      }
      if (activeTab == 2 && !newCategory.CustomerId) {
        alert('Please choose customer.');
        setLoading(false);
        return;
      }
      if (activeTab == 3 && !newCategory.CustomerId) {
        alert('Please choose customer.');
        setLoading(false);
        return;
      }
    }

    const formData = {
      CustomerId: parseInt(newCategory.CustomerId),
      CategoryId: parseInt(newCategory.CategoryId),
      ProductId: parseInt(newCategory.ProductId),
      DesignId: parseInt(newCategory.DesignId),
      ClientCode: clientCode,
      PurityId: parseInt(newCategory.PurityId),
      FinePercentage: `${newCategory.FinePercentage}`,
      CustomerName: `${newCategory.CustomerName}`,
      WastageWt: `${newCategory.WastageWt || ''}`,
      DiamondSizeWeightRateTemplateName: `${
        newCategory.DiamondSizeWeightRateTemplateName || ''
      }`,

      //    StoneLessPercent: `${newCategory.StoneLessPercent}`,
      MakingFixedAmt: `${newCategory.MakingFixedAmt}`,
      MakingPerGram: `${newCategory.MakingPerGram}`,
      MakingFixedWastage: `${newCategory.MakingFixedWastage}`,
      MakingPercentage: `${newCategory.MakingPercentage}`,
      StockKeepingUnit: newCategory.StockKeepingUnit,
      CompanyId: CompanyId ? CompanyId : 0,
      CounterId: CounterId ? CounterId : 0,
      BranchId: BranchId ? BranchId : 0,
      EmployeeId: EmployeeId ? EmployeeId : 0,
      DiamondSizeWeightRateTemplateId: parseInt(
        newCategory.DiamondSizeWeightRateTemplateId
      ),
      SKUList: [],
      Stones: newCategory?.Stones?.map((stone) => ({
        ...stone,
        CustomerId: parseInt(newCategory.CustomerId), // Update VendorId for each stone
      })),

      ...(editStatus ? { Id: editId } : {}),
    };

    let newArrayData;

    // Case 1: if VendorId, CategoryId, ProductId, and PurityId are not 0, empty, or null
    if (
      newCategory.CustomerId &&
      newCategory.CategoryId &&
      newCategory.ProductId &&
      newCategory.PurityId &&
      newCategory.DesignId
    ) {
      // Use existing logic for this case
      let newArray = allSelectedTounche
        .filter((x) => x.StockKeepingUnit !== newCategory.StockKeepingUnit)
        .map((item) => ({
          ...item,
          FinePure: newCategory.FinePure,
          CustomerId: parseInt(newCategory.CustomerId),
          CategoryId: parseInt(newCategory.CategoryId),
          ProductId: parseInt(newCategory.ProductId),
          ClientCode: clientCode,
          PurityId: parseInt(newCategory.PurityId),
          DesignId: parseInt(newCategory.DesignId),
          WastageWt: `${newCategory.WastageWt}`,
          MakingFixedAmt: `${newCategory.MakingFixedAmt}`,
          MakingPerGram: `${newCategory.MakingPerGram}`,
          MakingFixedWastage: `${newCategory.MakingFixedWastage}`,
          MakingPercentage: `${newCategory.MakingPercentage}`,
          FinePercentage: `${newCategory.FinePercentage}`,
          StockKeepingUnit: item.StockKeepingUnit,
          CompanyId: CompanyId ? CompanyId : 0,
          CounterId: CounterId ? CounterId : 0,
          BranchId: BranchId ? BranchId : 0,
          EmployeeId: EmployeeId ? EmployeeId : 0,
          DiamondSizeWeightRateTemplateId: parseInt(
            newCategory.DiamondSizeWeightRateTemplateId
          ),
          Stones: newCategory.Stones.map((stone) => ({
            ...stone,
            CustomerId: parseInt(newCategory.CustomerId), // Set VendorId for each stone
          })),
          SKUList: [],
        }));

      newArrayData = newArray.length > 0 ? [...newArray] : [formData];

      // Case 2: if VendorId and allSelectedTounche is not empty
    } else if (newCategory.CustomerId && allSelectedTounche.length > 0) {
      // Create SKUList from allSelectedTounche
      const SKUList = allSelectedSkus?.map((item) => ({
        // console.log('check items', item)

        CustomerId: parseInt(newCategory.VendorId),
        CategoryId: parseInt(item.CategoryId),
        ProductId: parseInt(item.ProductId),
        ClientCode: clientCode,
        PurityId: parseInt(item.PurityId),
        DesignId: parseInt(item.DesignId),
        StockKeepingUnit: item.StockKeepingUnit,
        CompanyId: CompanyId ? CompanyId : 0,
        CounterId: CounterId ? CounterId : 0,
        BranchId: BranchId ? BranchId : 0,
        EmployeeId: EmployeeId ? EmployeeId : 0,
        DiamondSizeWeightRateTemplateId: parseInt(
          newCategory.DiamondSizeWeightRateTemplateId
        ),
        FinePercentage: `${newCategory.FinePercentage}`, // Example FinePercentage value
      }));

      newArrayData = [
        {
          ...formData,
          SKUList: SKUList,
        },
      ];
    }

    const SKUList =
      // allSelectedTounche
      allSelectedSkus?.map((item) => ({
        // console.log('check items', item)

        CustomerId: parseInt(item.VendorId),
        VendorId: parseInt(item.VendorId),
        CategoryId: parseInt(item.CategoryId),
        ProductId: parseInt(item.ProductId),
        DesignId: parseInt(item.DesignId),
        ClientCode: clientCode,
        PurityId: parseInt(item.PurityId),
        StockKeepingUnit: item.StockKeepingUnit,
        CompanyId: CompanyId ? CompanyId : 0,
        CounterId: CounterId ? CounterId : 0,
        BranchId: BranchId ? BranchId : 0,
        EmployeeId: EmployeeId ? EmployeeId : 0,
        DiamondSizeWeightRateTemplateId: parseInt(
          newCategory.DiamondSizeWeightRateTemplateId
        ),
        FinePercentage: `${newCategory.FinePercentage}`, // Example FinePercentage value
      }));

    newArrayData = [
      {
        ...formData,
        SKUList: SKUList,
        Stones: allSelectedStones?.map((stone) => ({
          ...stone,
          // VendorId: parseInt(newCategory.CustomerId), // Update VendorId for each stone,
          CustomerId: parseInt(newCategory.CustomerId), // Update VendorId for each stone,
        })),
      },
    ];

    try {
      const response = await fetch(editStatus ? a747 : a744, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newArrayData),
      });
      const data = await response.json();
      fetchAllCategory();
      setActive('List');
      setAllSelectedTounche([]);
      setAllSelected(false);
      setAllSelectedSkus([]);
      setAllSelectedStones([]);

      setShowSKU(true);
      if (data.message) {
        // setMessageType("error");
        setMessageToShow(data.message);
        // setShowError(true);
        setActive('AddNew');
      } else {
        // setMessageType("success");
        toast.success('Customer Tounche Added Successfully', {
          duration: 3000,
          position: 'top-center',
        });
        if (editStatus) {
          navigate('/customer_tounche_new_list');
        } else {
          setNewCategory({
            CustomerId: 0,
            CategoryId: 0,
            ProductId: 0,
            DesignId: 0,
            ClientCode: '',
            PurityId: 0,
            FinePercentage: 0,
            StoneLessPercent: '0',
            MakingFixedAmt: '0',
            MakingPerGram: '0',
            MakingFixedWastage: '0',
            MakingPercentage: '0',
            StockKeepingUnit: '',
            CompanyId: 0,
            CounterId: 0,
            BranchId: 0,
            EmployeeId: 0,
            OldEntry: false,
            DiamondSizeWeightRateTemplateId: 0,
            Stones: [],
          });
        }
        // setShowError(true);
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
    } finally {
      refetch();
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setShowError(false);
    }, 2000);
  }, [showError]);

  const handleAllSelectedTounche = (e, x) => {
    const { value, checked } = e.target;
    if (checked) {
      const newTounche = {
        CustomerId: 0,
        CategoryId: 0,
        ProductId: 0,
        DesignId: 0,
        ClientCode: '',
        PurityId: 0,
        FinePercentage: 0,
        StoneLessPercent: '0',
        MakingFixedAmt: '0',
        MakingPerGram: '0',
        MakingFixedWastage: '0',
        MakingPercentage: '0',
        StockKeepingUnit: '',
        CompanyId: 0,
        CounterId: 0,
        BranchId: 0,
        EmployeeId: 0,
        OldEntry: false,
        DiamondSizeWeightRateTemplateId: 0,
      };
      newTounche.CustomerId = parseInt(newCategory.CustomerId);
      newTounche.CategoryId = parseInt(x.CategoryId);
      newTounche.ProductId = parseInt(x.ProductId);
      newTounche.DesignId = parseInt(x.DesignId);
      newTounche.PurityId = parseInt(x.PurityId);
      newTounche.ClientCode = clientCode;
      newTounche.FinePercentage = newCategory.FinePercentage;
      newTounche.StoneLessPercent = newCategory.StoneLessPercent;
      newTounche.MakingFixedAmt = newCategory.MakingFixedAmt;
      newTounche.MakingPerGram = newCategory.MakingPerGram;
      newTounche.MakingFixedWastage = newCategory.MakingFixedWastage;
      newTounche.MakingPercentage = newCategory.MakingPercentage;
      newTounche.StockKeepingUnit = x.StockKeepingUnit;
      newTounche.CompanyId = CompanyId ? CompanyId : 0;
      newTounche.CounterId = CounterId ? CounterId : 0;
      newTounche.BranchId = BranchId ? BranchId : 0;
      newTounche.EmployeeId = EmployeeId ? EmployeeId : 0;
      newTounche.DiamondSizeWeightRateTemplateId = parseInt(
        x.DiamondSizeWeightRateTemplateId
      );
      setAllSelectedTounche([...allSelectedTounche, newTounche]);
    } else {
      setAllSelectedTounche(
        allSelectedTounche.filter((item) => item.StockKeepingUnit !== value)
      );
    }
  };

  // -----------------------------------------------
  const [allSkuData, setAllSkuData] = useState([]);
  const [allStoneData, setAllStoneData] = useState([]);
  const [resetTableFn, setResetTableFn] = useState(null);
  const [resetTable, setResetTable] = useState(false);

  const handleResetField = () => {
    // List of all input and select refs

    // const allRefs = [
    //   inputRef1,
    //   inputRef2,
    //   inputRef3,
    //   inputRef4,
    //   inputRef5,
    //   inputRef6,
    //   inputRef7,
    //   inputRef8,
    //   inputRef9,
    //   inputRef10,
    //   inputRef11,
    // ];

    // Loop through each ref and reset the value
    // allRefs.forEach((ref) => {
    //   if (ref.current) {
    //     if (ref.current.tagName === "SELECT") {
    //       ref.current.selectedIndex = 0; // Reset <select> to the first option
    //     } else {
    //       ref.current.value = ""; // Clear input field
    //     }
    //   }
    // });

    // Refocus on the first input after reset
    // inputRef1.current?.focus();
    // setResetTable(true)
    // handleResetFromParent()
    // setAllSkuData([])
    if (editStatus) {
      setNewCategory(editData);
    } else {
      setNewCategory({
        // VendorId: 0,
        CustomerId: 0,
        CategoryId: 0,
        ProductId: 0,
        DesignId: 0,
        ClientCode: '',
        FinePure: false,
        PurityId: 0,
        FinePercentage: 0,
        WastageWt: '0',
        MakingFixedAmt: '0',
        MakingPerGram: '0',
        MakingFixedWastage: '0',
        MakingPercentage: '0',
        StockKeepingUnit: '',
        CompanyId: 0,
        CounterId: 0,
        BranchId: 0,
        EmployeeId: 0,
        OldEntry: false,
        DiamondSizeWeightRateTemplateId: 0,
        Stones: [],
      });
    }
  };
  useEffect(() => {
    let filteredItems = [];
    //----------filtering sku items according to conditions---------
    if (
      newCategory.CustomerId &&
      !newCategory.CategoryId &&
      !newCategory.ProductId &&
      !newCategory.DesignId &&
      !newCategory.PurityId
    ) {
      filteredItems = allSku;
      // allSku?.filter(
      //   (item) => item?.VendorId == newCategory.CustomerId
      // );
    }
    if (
      newCategory.CustomerId &&
      newCategory.CategoryId &&
      !newCategory.ProductId &&
      !newCategory.DesignId &&
      !newCategory.PurityId
    ) {
      filteredItems = allSku?.filter(
        (item) => item?.CategoryId == newCategory.CategoryId
      );
    }
    if (
      newCategory.CustomerId &&
      newCategory.CategoryId &&
      newCategory.ProductId &&
      !newCategory.DesignId &&
      !newCategory.PurityId
    ) {
      filteredItems = allSku?.filter(
        (item) =>
          item?.CategoryId == newCategory.CategoryId &&
          item?.ProductId == newCategory.ProductId
      );
    }
    if (
      newCategory.CustomerId &&
      newCategory.CategoryId &&
      newCategory.ProductId &&
      newCategory.DesignId &&
      !newCategory.PurityId
    ) {
      filteredItems = allSku?.filter(
        (item) =>
          item?.CategoryId == newCategory.CategoryId &&
          item?.ProductId == newCategory.ProductId &&
          item?.DesignId == newCategory.DesignId
      );
    }
    if (
      newCategory.CustomerId &&
      newCategory.CategoryId &&
      newCategory.ProductId &&
      newCategory.DesignId &&
      newCategory.PurityId
    ) {
      filteredItems = allSku?.filter(
        (item) =>
          item?.CategoryId == newCategory.CategoryId &&
          item?.ProductId == newCategory.ProductId &&
          item?.DesignId == newCategory.DesignId &&
          item?.PurityId == newCategory.PurityId
      );
    }

    setAllSkuData(filteredItems);
  }, [
    allSku,
    newCategory.CustomerId,
    newCategory.CategoryId,
    newCategory.ProductId,
    newCategory.PurityId,
    newCategory.DesignId,
  ]);

  useEffect(() => {
    let result = [];
    const foundCustomer = allCustomerTounch?.find(
      (customer) =>
        customer?.CustomerId == newCategory?.CustomerId &&
        newCategory?.CustomerId != 0
    );

    if (allStones?.length) {
      if (foundCustomer?.Id && foundCustomer?.Id != 0) {
        const filteredStones = [];
        allStones?.forEach((stone) => {
          const found = foundCustomer?.Stones?.find(
            (st) => st?.StoneId == stone?.Id
          );
          if (!found?.StoneId) {
            filteredStones.push({ ...stone, StoneRate: '0' });
          }
        });
        result = [...foundCustomer?.Stones, ...filteredStones];
      } else {
        allStones?.forEach((stone) => {
          result.push({ ...stone, StoneRate: '0' });
        });
      }
    }
    console.log(result);
    // ------converting stones into proper format-------------
    const formatedStones = result?.map((stone) => ({
      CustomerId: 0, // Keep CustomerId as 0
      // VendorId: 0, // Keep VendorId as 0 for now, will change later
      Id: stone?.Id || stone?.StoneId,
      StoneId: stone?.Id || stone?.StoneId,
      StoneName: stone.StoneName,
      StoneWeight: stone.StoneWeight,
      StonePieces: stone.StonePieces,
      StoneRate: stone.StoneRate,
      StoneAmount: stone.StoneAmount,
      StoneLessPercent: stone.StoneLessPercent,

      StoneCertificate: stone?.StoneCertificate,
      StoneSettingType: stone?.StoneSettingType,
      StoneCategory: stone?.StoneCategory,
      StoneColour: stone?.StoneColour,
      StoneShape: stone?.StoneShape,
      StoneSize: stone?.StoneSize,
      StoneRatePerPiece: stone?.StoneRatePerPiece,
      StoneWeightType: stone?.StoneWeightType,
    }));
    console.log(formatedStones);
    setAllStoneData(formatedStones);
  }, [allCustomerTounch, allStones, newCategory?.CustomerId, activeTab]);

  return (
    <div>
      <AdminHeading />
      <div style={{ paddingTop: '130px' }}>
        {showError ? (
          <AlertMessage message={messageToShow} type={messageType} />
        ) : null}
        <AdminBreadCrump
          title={'Add Customer Tounche'}
          companyName={'Loyalstring'}
          module={'Settings'}
          page={'Customer Tounche'}
        />
      </div>
      <div style={{ padding: '16px' }}>
        <>
          <div className={style.adminAddCategoryMainBox}>
            <div className={style.adminAddCategoryInnerBox}>
              <div className={style.adminCategoryAddCategoryMainBox}>
                <form style={{ width: '100%' }} onSubmit={addNewCategory}>
                  <div
                    style={{
                      gridTemplateColumns: 'repeat(4,2fr)',
                      columnGap: '30px',
                      margin: '0px 0px',
                      padding: 'var(--Space-0, 0px) 24px',
                    }}
                    // className="adminCategoryAddCategoryInnerBox"
                  >
                    <Box sx={{ width: '95%', margin: '0 auto' }}>
                      <div style={{ display: 'flex', margin: '20px 0px' }}>
                        <button
                          type="button" // Add this
                          style={{
                            marginRight: '10px',
                            border: `${
                              activeTab == 1 ? '2px solid black' : ''
                            }`,
                          }}
                          onClick={() => {
                            setActiveTab(1);
                          }}
                        >
                          <Icon icon="lucide:boxes" width="18" height="18" />
                          SKU Selection
                        </button>
                        <button
                          type="button" // Add this
                          style={{
                            marginRight: '10px',
                            border: `${
                              activeTab == 2 ? '2px solid black' : ''
                            }`,
                          }}
                          onClick={() => {
                            setActiveTab(2);
                          }}
                        >
                          <Icon icon="lucide:boxes" width="18" height="18" />
                          Stone Selection
                        </button>
                        <button
                          type="button" // Add this
                          style={{
                            marginRight: '10px',
                            border: `${
                              activeTab == 3 ? '2px solid black' : ''
                            }`,
                          }}
                          onClick={() => {
                            setActiveTab(3);
                          }}
                        >
                          <Icon icon="lucide:boxes" width="18" height="18" />
                          Template Selection
                        </button>
                      </div>

                      <div
                        style={{
                          gridTemplateColumns: 'repeat(4,1fr)',
                          columnGap: '40px',
                          margin: '15px 0px',
                        }}
                        className="adminCategoryAddCategoryInnerBox"
                      >
                        <label>
                          Select Customer : <sup>*</sup>
                        </label>
                        <select
                          ref={inputRef1}
                          onKeyDown={(e) => handleKeyPress(e, inputRef2)}
                          name="CustomerId"
                          value={newCategory?.CustomerId}
                          onChange={handleNewCategoryChange}
                          required={'required'}
                        >
                          <option value={''}>Select an Option</option>
                          {allCustomers?.map((x) => {
                            return (
                              <option value={x.Id}>
                                {/* {x.Id} - {x.VendorName} */}
                                {`${x?.FirstName} - ${x?.Id}`}
                              </option>
                            );
                          })}
                        </select>

                        {activeTab == 1 && (
                          <>
                            <label>
                              Select Category <sup>*</sup>
                            </label>
                            <select
                              ref={inputRef2}
                              onKeyDown={(e) => handleKeyPress(e, inputRef3)}
                              name="CategoryId"
                              value={newCategory.CategoryId}
                              onChange={handleNewCategoryChange}
                              //    required={"required"}
                            >
                              <option value={''}>Select an Option</option>
                              {categoriesData?.map((x) => {
                                return (
                                  <option value={x.Id}>{x.CategoryName}</option>
                                );
                              })}
                            </select>
                          </>
                        )}
                        {activeTab == 1 && (
                          <>
                            <label>
                              Select Product<sup>*</sup>
                            </label>
                            <select
                              ref={inputRef3}
                              onKeyDown={(e) => handleKeyPress(e, inputRef4)}
                              name="ProductId"
                              value={newCategory?.ProductId}
                              onChange={handleNewCategoryChange}
                              //    required={"required"}
                            >
                              <option value={''}>Select an Option</option>
                              {productsData
                                ?.filter(
                                  (pro) =>
                                    pro?.CategoryId ==
                                    parseInt(newCategory?.CategoryId)
                                )
                                ?.map((x) => {
                                  return (
                                    <option value={x?.Id}>
                                      {x?.ProductName}
                                    </option>
                                  );
                                })}
                            </select>
                          </>
                        )}
                        {activeTab == 1 && (
                          <>
                            <label>
                              Select Design<sup>*</sup>
                            </label>
                            <select
                              ref={inputRef4}
                              onKeyDown={(e) => handleKeyPress(e, inputRef5)}
                              name="DesignId"
                              value={newCategory.DesignId}
                              onChange={handleNewCategoryChange}
                              //    required={"required"}
                            >
                              <option value={''}>Select an Option</option>
                              {designData
                                ?.filter(
                                  (pro) =>
                                    pro?.ProductId ==
                                    parseInt(newCategory?.ProductId)
                                )
                                ?.map((x) => {
                                  return (
                                    <option value={x.Id}>
                                      {x?.DesignName}
                                    </option>
                                  );
                                })}
                            </select>
                          </>
                        )}
                        {activeTab == 1 && (
                          <>
                            <label>
                              Select Purity<sup>*</sup>
                            </label>
                            <select
                              ref={inputRef5}
                              onKeyDown={(e) => handleKeyPress(e, inputRef6)}
                              name="PurityId"
                              value={newCategory.PurityId}
                              onChange={handleNewCategoryChange}
                              //    required={"required"}
                            >
                              <option value={''}>Select an Option</option>
                              {purityData
                                ?.filter(
                                  (item) =>
                                    item?.CategoryId ==
                                    parseInt(newCategory?.CategoryId)
                                )
                                ?.map((x) => {
                                  return (
                                    <option value={x?.Id}>
                                      {x?.PurityName}
                                    </option>
                                  );
                                })}
                            </select>
                          </>
                        )}
                        {activeTab == 1 && (
                          <>
                            <label>Fine Percentage</label>
                            <input
                              ref={inputRef6}
                              onKeyDown={(e) => handleKeyPress(e, inputRef7)}
                              name="FinePercentage"
                              value={newCategory.FinePercentage}
                              onChange={handleNewCategoryChange}
                              type="text"
                              style={{ border: '1px solid #ddd' }}
                            />
                          </>
                        )}
                        {/* <label>Stone Less Percent</label>
                                   <input
                                       name="StoneLessPercent"
                                       value={newCategory.StoneLessPercent}
                                       onChange={handleNewCategoryChange}
                                       type="text"
                                   /> */}
                        {activeTab == 1 && (
                          <>
                            <label>Making Fixed Amt</label>
                            <input
                              ref={inputRef7}
                              onKeyDown={(e) => handleKeyPress(e, inputRef8)}
                              name="MakingFixedAmt"
                              value={newCategory.MakingFixedAmt}
                              onChange={handleNewCategoryChange}
                              type="text"
                              style={{ border: '1px solid #ddd' }}
                            />
                          </>
                        )}
                        {activeTab == 1 && (
                          <>
                            <label>Wastage Percentage</label>
                            <input
                              ref={inputRef8}
                              onKeyDown={(e) => handleKeyPress(e, inputRef9)}
                              name="MakingPercentage"
                              value={newCategory.MakingPercentage}
                              onChange={handleNewCategoryChange}
                              type="text"
                              style={{ border: '1px solid #ddd' }}
                            />
                          </>
                        )}
                        {activeTab == 1 && (
                          <>
                            <label>Making/Gm</label>
                            <input
                              ref={inputRef9}
                              onKeyDown={(e) => handleKeyPress(e, inputRef10)}
                              name="MakingPerGram"
                              value={newCategory.MakingPerGram}
                              onChange={handleNewCategoryChange}
                              type="text"
                              style={{ border: '1px solid #ddd' }}
                            />
                          </>
                        )}
                        {activeTab == 1 && (
                          <>
                            <label>Making Fixed Wastage</label>
                            <input
                              ref={inputRef10}
                              onKeyDown={(e) => handleKeyPress(e, inputRef11)}
                              name="MakingFixedWastage"
                              value={newCategory.MakingFixedWastage}
                              onChange={handleNewCategoryChange}
                              type="text"
                              style={{ border: '1px solid #ddd' }}
                            />
                          </>
                        )}
                        {activeTab == 3 && (
                          <>
                            <label>Diamond Template :</label>{' '}
                            {/*changed the title from "Select template" to "Diamond Template"*/}
                            <select
                              ref={inputRef11}
                              onKeyDown={(e) => handleKeyPress(e, inputRef1)}
                              name="DiamondSizeWeightRateTemplateId"
                              value={
                                newCategory.DiamondSizeWeightRateTemplateId
                              }
                              onChange={handleNewCategoryChange}
                            >
                              <option value={''}>Select an Template</option>
                              {templateData?.map((x) => {
                                return (
                                  <option
                                    value={x?.templateID}
                                    key={x.templateID}
                                  >
                                    {x.templateName}
                                  </option>
                                );
                              })}
                            </select>
                          </>
                        )}
                      </div>
                    </Box>
                  </div>

                  {/* <div
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      padding: "0px 44px",
                    }}
                  >
                    <button
                      type="button" // Add this
                      style={{
                        border: `${showSKU == true ? "2px solid black" : ""}`,
                      }}
                      onClick={() => {
                        setShowSKU(true);
                      }}
                    >
                      <Icon icon="lucide:boxes" width="18" height="18" />
                      SKU
                    </button>
                    <button
                      type="button" // Add this
                      style={{
                        border: `${showSKU == false ? "2px solid black" : ""}`,
                      }}
                      onClick={() => {
                        setShowSKU(false);
                      }}
                    >
                      <Icon
                        icon="tabler:hexagonal-pyramid"
                        width="18"
                        height="18"
                      />
                      Stones
                    </button>
                  </div> */}

                  {activeTab == 1 ? (
                    <div
                      style={{
                        overflowX: 'auto',
                        // borderTop: "1px solid rgba(0,0,0,0.2)",
                        // borderBottom: "1px solid rgba(0,0,0,0.2)",
                        marginTop: '30px',
                        // marginBottom: "20px",
                      }}
                    >
                      <TounchSkuTable
                        columns={VendorTounchSkuColumns}
                        data={allSkuData}
                        setAllSelectedSkus={setAllSelectedSkus}
                        isReset={isReset}
                        resetTable={resetTable}
                        onReset={(resetFn) => setResetTableFn(() => resetFn)}
                        isStoneTable={false}
                      />
                    </div>
                  ) : activeTab == 2 ? (
                    // Render alternate UI here
                    <div style={{ marginBottom: '20px' }}>
                      <TounchSkuTable
                        columns={VendorTounchStonesColumns}
                        data={
                          newCategory?.CustomerId && allStoneData?.length
                            ? allStoneData
                            : []
                        }
                        setAllSelectedSkus={setAllSelectedStones}
                        isReset={isReset}
                        resetTable={resetTable}
                        isStoneTable={true}
                      />
                    </div>
                  ) : (
                    ''
                  )}

                  {!loading ? (
                    <div
                      style={{ marginBottom: '20px' }}
                      className={style['btn-container']}
                    >
                      <button style={{ marginTop: '20px' }}>
                        <Icon width="24px" icon="ic:sharp-check" /> Submit
                      </button>
                      <button
                        onClick={handleResetField}
                        style={{
                          marginTop: '20px',
                          display: 'flex',
                          height: '32px',
                          justifyContent: 'center',
                          alignItems: 'center',
                          borderRadius: '5px',
                          background: '#fff',
                          color: '#0077d4',
                          border: '1px solid #0077d4',
                          cursor: 'pointer',
                        }}
                      >
                        <Icon
                          width="24px"
                          icon="ix:reset"
                          style={{ color: '#0077D4' }}
                        />{' '}
                        Reset
                      </button>
                      <button
                        style={{ marginTop: '20px' }}
                        type="button"
                        onClick={() => navigate('/customer_tounche_new_list')}
                      >
                        <Icon width="24px" icon="fluent:list-rtl-16-filled" />{' '}
                        List
                      </button>
                    </div>
                  ) : null}
                </form>
              </div>
            </div>
          </div>
        </>
      </div>
    </div>
  );
}
